export default [
  ["#34e95c", "#d012a3", "#1212d0"],
  ["#c2f6b2", "#3d054d", "#05154d"],
  ["#8ada6b", "#752195", "#214195"],
  ["#ceb61b", "#2d46ea", "#2DEAD1"],
  ["#b63413", "#01c7f8", "#01f832"],
  [("#062583", "#FDDFDB")],
  ["#363378", "#F9747D"]
];

export const black = "#262626";

export const gray = "#5C5D60";

export const teal = "#009E99";

export const lime = "#8ada6b";

export const blue = "28213C";



// WEBPACK FOOTER //
// ./src/styles/colors.js